import { validation } from 'site-modules/shared/components/form-validation/validation';
import { asyncValidation } from 'site-modules/shared/components/form-validation/validation-async';

export const EMAIL_ERROR_ID = 'dealer-review-email-error';
export const FIELD_DANGER_CLASS_NAMES = 'field-danger text-danger medium mb-0_25';
export const MAX_REVIEW_TITLE_LENGTH = 75;
export const MAX_REVIEW_TEXT_LENGTH = 7500;
export const MAX_REVIEW_AUTHOR_NAME_LENGTH = 30;
export const FORM_FIELD_CLASS_NAMES = {
  className: 'mb-0',
  labelClassName: 'heading-5 mb-0_25',
};
export const OPTION_LIST = [{ title: 'Yes' }, { title: 'No' }];
export const FORM_FIELD_NAMES = {
  AUTHOR_NAME: 'authorName',
  EMAIL: 'email',
  USER_RATING: 'userRating',
  TITLE: 'title',
  TEXT: 'text',
  COMMENT: 'comment',
};
export const FORM_VALIDATORS = {
  [FORM_FIELD_NAMES.AUTHOR_NAME]: {
    test: validation.validateDisplayName,
    errorText: 'Please add Author Name or Nickname (only letters, numbers, or spaces accepted)',
  },
  [FORM_FIELD_NAMES.EMAIL]: {
    test: validation.validateEmail,
    asyncTest: (params, options) => asyncValidation.fetchEmailValidation({ ...params, id: 'insider' }, options),
    errorText: 'Please add an email address',
  },
  [FORM_FIELD_NAMES.USER_RATING]: {
    test: validation.validateValue,
    errorText: 'Please add an overall rating',
  },
  [FORM_FIELD_NAMES.TITLE]: {
    test: validation.validateValue,
    errorText: 'Please add a review title',
  },
  [FORM_FIELD_NAMES.TEXT]: {
    test: validation.validateValue,
    errorText: 'Please add a review',
  },
  [FORM_FIELD_NAMES.COMMENT]: {
    test: validation.validateValue,
    errorText: 'Please add a comment',
  },
};
